export default (value: any) => {
    switch (String(value)) {
        case "1": return "Più qualificato per altra mansione";
        case "2": return "Assumere";
        case "3": return "Da Risentire";
        case "4": return "Non Assumere";
    }
}